import classNames from 'clsx'
import { type FC } from 'react'

import { filterKeys } from 'shared/utils/objectUtils'

import './Icon.scss'

// Doesn’t matter much what value we use here, since images size will be
// given by CSS. We set width and height to let browser know about
// images’s aspect ratio.
const SIZE = 24

interface IconImageNativeProps {
  alt: string
  src: string
  size?: string
  className?: string
}
export type IconImageProps = IconImageNativeProps & {
  [dataAttrName: string]: string | undefined
}

const IconImage: FC<IconImageProps> = ({
  alt,
  src,
  size = 'default',
  className,
  ...dataAttrs
}) => {
  const iconClassName = classNames(
    'a-Icon',
    size === 'default' ? null : `a-Icon--${size}`,
    className
  )

  const onlyDataAttrs = filterKeys(
    // @ts-ignore
    (key: string) => key.startsWith('data-'),
    dataAttrs
  )

  return (
    <img
      alt={alt}
      src={src}
      width={SIZE}
      height={SIZE}
      className={iconClassName}
      {...onlyDataAttrs}
    />
  )
}

export default IconImage
